var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Spot"
  }, [_c('InputFieldWithLabel', {
    attrs: {
      "value": _vm.tempValue,
      "options": _vm.itemsFormatted,
      "label": _vm.label,
      "isRequired": _vm.required
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }